import { connect } from 'react-redux';
import { Button, TextField } from '@devfolioco/genesis';
import React, { Component } from 'react';

import { SAVE } from '@constants';
import { ERRORS } from '@constants/errors';
import { checkEmailAvailabilityAndSendOTP, setUserState } from 'actions/user';

class EditEmail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: props.currentEmail || '',
    };
  }

  componentDidUpdate(prevProps) {
    const { saveStatus, error, updateViewState, updateCurrentEmail } = this.props;
    const { email } = this.state;

    if (saveStatus !== prevProps.saveStatus) {
      if (saveStatus === SAVE.SUCCESS && !error.length) {
        updateCurrentEmail(email);
        updateViewState('VERIFY');
      }
    }
  }

  handleFormSubmit = event => {
    event.preventDefault();

    const { email } = this.state;
    const { dispatchUpdateEmail } = this.props;

    dispatchUpdateEmail(email);
  };

  handleInputChange = ({ target }) => {
    const { name, value } = target;
    this.setState({ [name]: value });

    if (name === 'email') {
      const { dispatchClearErrors } = this.props;
      dispatchClearErrors();
    }
  };

  render() {
    const { error, saveStatus } = this.props;
    const { email } = this.state;

    return (
      <form onSubmit={this.handleFormSubmit}>
        <TextField
          value={email}
          label="Email Address"
          name="email"
          onChange={this.handleInputChange}
          required
          autoFocus
          spellCheck={false}
          type="email"
          error={{
            [ERRORS.emailDuplicate]: error === ERRORS.emailDuplicate,
            [ERRORS.emailInvalid]: error === ERRORS.emailInvalid,
          }}
        />

        <Button
          type="submit"
          stretch
          disabled={error === ERRORS.emailInvalid || error === ERRORS.emailDuplicate}
          loading={saveStatus === SAVE.PROGRESS}
        >
          Send verification code
        </Button>
      </form>
    );
  }
}

const mapStateToProps = ({ authentication, user }) => ({
  error: user.error || '',
  isEmailVerified: user.isEmailVerified,
  saveStatus: user.saveStatus,
  username: authentication.username,
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateEmail: email => {
    dispatch(checkEmailAvailabilityAndSendOTP(email, false));
  },
  dispatchClearErrors: () => {
    dispatch(setUserState('error', ''));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditEmail);
